import { useFavoriteToggleContext } from '#baseMenu/components';
import { useAdvertFavoriteVisibleControl } from '#advertFavorite/hooks';
import { useMenuActionControlProviderContext, useMenuActionsBlocker } from '#baseMenu/hooks';

const useFavoriteToggleHandlerClick = () => {
  const { isOpen, open, hide } = useAdvertFavoriteVisibleControl();
  const {
    AdvertFavoriteBottomSheet,
    isLoaded,
    setIsLoaded,
    setIsLoadInProcess,
  } = useFavoriteToggleContext();
  const { menuActionControl } = useMenuActionControlProviderContext();
  const { blockActions, unblockActions } = useMenuActionsBlocker();

  return () => {
    if (!isLoaded) {
      blockActions();
      setIsLoadInProcess(true);
      AdvertFavoriteBottomSheet.load().then(() => {
        setIsLoaded(true);
        setIsLoadInProcess(false);
        menuActionControl.hide().then(() => {
          unblockActions();
          setIsLoadInProcess(false);
          open();
          menuActionControl.add({ id: 'advertFavorite', hide });
        });
      });
      return;
    }

    if (isOpen) {
      hide();
      menuActionControl.remove('advertFavorite');
    } else {
      menuActionControl.hide().then(() => {
        open();
        menuActionControl.add({ id: 'advertFavorite', hide });
      });
    }
  };
};

export { useFavoriteToggleHandlerClick };
